import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import LoginPage from "./screens/login/Login";
import Dashboard from "./screens/dashboard/dashboard";
import RazorpayReturn from "./screens/payments/RazorpayReturn";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "font-awesome/css/font-awesome.min.css";
import './App.css';

function App() {
  const ProtectedRoute = () => {
    const token = localStorage.getItem("doctorId");
    return token ? <Outlet /> : <Navigate to="/" replace />;
  };

  const PublicRoute = () => {
    const token = localStorage.getItem("doctorId");
    return token ? <Navigate to="/dashboard" replace /> : <Outlet />;
  };

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route element={<PublicRoute />}>
            <Route index element={<LoginPage />} />
          </Route>

          {/* Razorpay return — plink_xxx appended at end of URL */}
          <Route path="/payments/razorpay/return/:paymentLinkId" element={<RazorpayReturn />} />
          <Route path="/payments/razorpay/return" element={<RazorpayReturn />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
